<template>
  <div class="form-list-card" :class="{'active' : $route.name === 'activeLeads' && data.isFormSelected}" >
    <div class="flex list-section">
      <div class="flex">
        <img :src="data.image ? data.image.original : defaultImage" alt="">
        <div>
          <h4 class="secondary-font">{{data.name}}</h4>

          <div class="flex" style="text-align: center; color: #3A6ACA9; justify-content : flex-start;">
            <small style="color: #727B76">by {{data.user.full_name}} </small>
            <small style="color: #727B76 " class="mx-3">
                <time-ago :refresh="60" :datetime="(data.published_at)" long   />
            </small>
          </div>
        </div>
      </div>
      
      
      <div class="form-action">
        <img :src="defaultImage" alt="" class="pointer" @click="getFormDetails(data.form_id)">

        <button
          v-if="$route.name !== 'activeLeads' || !data.isFormSelected"
          class="formBtn --green mr-2"
          style="background: rgba(49, 138, 54, 0.05)"
          @click="postDetails.postID ? attachFormDirectly({formName : data.name, ID : data.form_id}) : takeFormID({formName : data.name, ID : data.form_id})"
        >
          Select this form
        </button>
      </div>

      <!-- <button
        class="formBtn --grey"
        style="background: #fafafa; color: #757575"
      >
        Edit this form
      </button> -->
      <!-- <button
        class="formBtn --green"
        style="background: #fafafa; color: #c84141; margin-right: 1rem"
      >
        Delete this form
      </button> -->
    </div>

    <v-overlay opacity="0.3" color="black" v-if="loader">
        <v-progress-circular indeterminate color="#1F8F58"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import { TimeAgo } from "vue2-timeago";
import accessToken from '../../../../helpers/accessToken';
import API_URL from "../../../../helpers/apiUrls";
import { eventBus } from '../../../../main';
export default {
  name: "formList",

  data() {
    return {
      defaultImage : require("../../../../assets/MainDashboard/ActiveLeads/FormListDefault.svg"),
      contentID : '',
      postType : '',
      loader  : false,
    }
  },

  props : {
    data : {
      type : Object
    },
  },

  computed : {
    postDetails() {
      return this.$store.getters['createContentStore/GET_SELECTED_FORM']
    }
  },

  methods : {
    takeFormID(data) {
      if(this.$route.name === 'activeLeads') {
        this.$emit('getLeads', data);
        this.$store.state.activeLeadsStore.formList.forEach(list => {
          if(list.isFormSelected)
            list.isFormSelected = false;

          if(list.form_id === data.ID) {
            list.isFormSelected = true;
          }            
        })
      }
      else {
        this.$store.state.createContentStore.selectedForm.ID = data.ID;
        this.$store.state.createContentStore.selectedForm.formName = data.formName;
        eventBus.$emit("formSelected");
      }
    },

    attachFormDirectly(data) {
      const payload = {
				form : data.ID,
				post_id : this.postDetails.postID,
				post_type : this.postDetails.postType
			}
			this.$store.dispatch('createContentStore/attachFormWithPost', payload);
      eventBus.$emit("formSelected", "refresh");
    },

    getFormDetails(ID) {
      this.loader = true;
      const successHandler = response => {
        if(response.status === 200) {
          this.$emit('formDetails', response.data);
          this.loader = false;
        }
      }

      const errorHandler = error => {
        this.showToast('Something went wrong internally!', 'error', 10000);
        this.loader = false;
        console.log(error);
      }

      const data = {
        form_id : ID
      }

      const headers = {
        'Authorization' : `Bearer ${accessToken.getAccessToken()}` 
      }

      this.requestGET(
        API_URL.activeleads__formDetails,
        data,
        headers,
        successHandler,
        errorHandler
      )
    }
  },

  components:{
    "time-ago": TimeAgo,
  }
};
</script>

<style scoped lang="scss">

.form-list-card {
  margin-top: 10px;
  background-color: white;
  padding-left: 10px;
  border-radius: 5px;
  box-shadow: 1px 1px 1px rgba(17, 58, 34, 0.07);
  box-sizing: border-box;

  &.active {
    border: 2px solid #1D8D56;
  }

  &.active h4 {
    color: var(--primary-color);
  }
}

.list-section {
  justify-content: space-between;
  border-radius: 5px;
  box-shadow: 1px 1px 2px rgba(17, 58, 34, 0.19);
  padding: 15px 0px;
}

.list-section > div:nth-child(2) {
  width: 40%;
}

.list-section > div:nth-child(2) img {
  background: linear-gradient(0deg, #EFF6F3, #EFF6F3);
  border-radius: 5px;
}

.formBtn {
  padding: 15px 10px;
  font-size: 0.8rem;
  justify-content: center;
  height: 51px;
  border-radius: 7px;
}

img {
  width: 50px;
  height: 50px;
  margin-right: 15px;
  object-fit: cover;
  border-radius: 7px;
  margin-left: auto;
}

.form-action {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  justify-items: right;
}

</style>